import { Fragment } from 'react';

import { RepresentativeForm, type IRepresentativeForm } from 'src/components/Escrow/Representative';
import { AgreementFormEnum, EscrowPartyTypeEnum } from 'src/graphql/schema';
import { DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

import { useRepresentative } from '../model';

const AddRepresentative = () => {
  const { submit, setInitialData, agreementType, role } = useRepresentative();

  const onSubmit = async (values: IRepresentativeForm) => {
    await submit?.add(values);
    setInitialData();
  };

  const showSignatory =
    agreementType === AgreementFormEnum.Tripartite ||
    (agreementType === AgreementFormEnum.Bipartite && role === EscrowPartyTypeEnum.Depositor);

  return (
    <Fragment>
      <DialogHeader>
        <DialogTitle className="text-base font-bold">Add Representative</DialogTitle>
        <DialogDescription>This person will be listed in the escrow agreement as a point of contact.</DialogDescription>
      </DialogHeader>
      <RepresentativeForm
        onCancel={setInitialData}
        onSubmit={onSubmit}
        withSignatory={showSignatory}
        initialValues={{
          name: '',
          email: '',
          phone: '',
          signatory: false,
        }}
      />
    </Fragment>
  );
};

export default AddRepresentative;
